import { render, staticRenderFns } from "./Sandpit.vue?vue&type=template&id=1843cf77&scoped=true"
import script from "./Sandpit.vue?vue&type=script&lang=js"
export * from "./Sandpit.vue?vue&type=script&lang=js"
import style0 from "./Sandpit.vue?vue&type=style&index=0&id=1843cf77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843cf77",
  null
  
)

export default component.exports